import { Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { VerityEnvironmentService } from '../../../environments/verity-environment.service'

@Component({
  standalone: false,
  templateUrl: './verity-redirect.component.html',
  styleUrls: ['./verity-redirect.component.scss'],
})
export class VerityRedirectComponent {
  private verityEnvironmentService = inject(VerityEnvironmentService)
  private activatedRoute = inject(ActivatedRoute)

  // Defaults to false (the safer, no-dead-end-button state) if landed on
  // directly without the query param, e.g. a bookmark or a page refresh.
  public hasVerityAccess =
    this.activatedRoute.snapshot.queryParamMap.get('hasVerityAccess') === 'true'

  public goToVerity(): void {
    window.location.href = this.verityEnvironmentService.verityConfig.appUrl
  }

  public contactSupport(): void {
    const subject = encodeURIComponent('Need access to Verity')
    const body = encodeURIComponent(
      "I'm trying to access Verity and need help getting set up.",
    )
    window.location.href = `mailto:support@intel471.com?subject=${subject}&body=${body}`
  }
}
